module.exports = __webpack_public_path__ + "images/questions/qa_store_answer_764fc31bb93d9065387202597eaace90.png";